export const IDS = {
  nav: {
    root: "nav-root",
    logo: "nav-logo",
    home: "nav-home",
    about: "nav-about",
    practice: "nav-practice",
    team: "nav-team",
    insights: "nav-insights",
    contact: "nav-contact",
    cta: "nav-cta",
    menuToggle: "nav-menu-toggle",
  },
  home: {
    hero: "home-hero",
    heroCta: "home-hero-cta",
    marquee: "home-marquee",
    manifesto: "home-manifesto",
    heritage: "home-heritage",
    practice: "home-practice",
    team: "home-team",
    testimonials: "home-testimonials",
    contactCta: "home-contact-cta",
  },
  contact: {
    form: "contact-form",
    name: "contact-name",
    email: "contact-email",
    business: "contact-business",
    message: "contact-message",
    submit: "contact-submit",
    success: "contact-success",
    error: "contact-error",
  },
  footer: {
    root: "footer-root",
  },
};
